import { useMemo, useEffect, useState } from "react";
import { HEADER_FIELDS } from "./Fields";
import { getDataWithComp, getAlert, getData } from "../../../../utils/SamuiUtils";
import moment from "moment";

export default function useJobAssignment({
  startDate,
  endDate,
  search = "",
  sortField,
  sortOrder,
  page,
  perPage,
  statusFilter,
}) {
  const [rawData, setRawData] = useState([]);
  const [jobImages, setJobImages] = useState({});

  useEffect(() => {
    getDataWithComp("API_1801_JOB", "Order By job_no ASC, job_time ASC")
      .then((data) => {
        setRawData(data || []);
      })
      .catch((e) => getAlert("FAILED", e.message));
  }, []);
  useEffect(() => {
    const loadImages = async () => {
      const result = {};
      for (const job of rawData) {
        try {
          const images = await getData("Upload_File_List", `DocCode_ID = 9 AND doc_id = ${job.job_id} AND file_status = 'Y' AND job_time = ${job.job_time}`);
          result[`${job.job_id}_${job.job_time}`] = images.map(img => img.File_Name);
        } catch (e) {
          console.error("โหลดรูปภาพล้มเหลว:", e.message);
        }
      }
      setJobImages(result);
    };

    if (rawData.length > 0) {
      loadImages();
    }
  }, [rawData]);

  const filtered = useMemo(() => {
    return rawData.filter((item) => {
      const keyword = search.toLowerCase();
      const statusMatch = !statusFilter || item.job_status_name === statusFilter;

      const jobDate = item.job_date ? new Date(item.job_date) : null;
      const start = new Date(startDate);
      const end = new Date(endDate);
      const dateMatch = jobDate && jobDate >= start && jobDate <= end;

      const searchMatch =
        !search ||
        item.AR_Code?.toLowerCase().includes(keyword) ||
        item.AR_Name?.toLowerCase().includes(keyword) ||
        item.job_no?.toLowerCase().includes(keyword);

      return searchMatch && statusMatch && dateMatch;
    });
  }, [rawData, search, statusFilter, startDate, endDate]);

  const searched = useMemo(() => {
    return filtered.map((item) => {
      const key = `${item.job_id}_${item.job_time}`;
      return {
        ...item,
        job_date: item.job_date ? moment(item.job_date).format("DD/MM/YYYY") : "",
        srv_date: item.srv_date ? moment(item.srv_date).format("DD/MM/YYYY") : "",
        job_status_name: item.job_status_name || "รอเข้าพบ",
        images: jobImages[key] || []
      };
    });
  }, [filtered, jobImages]);


  const sorted = useMemo(() => {
    if (!sortField) return searched;
    return [...searched].sort((a, b) => {
      let va = a[sortField];
      let vb = b[sortField];
      if (typeof va === "string") va = va.toLowerCase();
      if (typeof vb === "string") vb = vb.toLowerCase();
      if (va > vb) return sortOrder === "asc" ? 1 : -1;
      if (va < vb) return sortOrder === "asc" ? -1 : 1;
      return 0;
    });
  }, [searched, sortField, sortOrder]);

  const current = sorted;
  const total = sorted.length;
  const pages = 1;
  const sums = { sumNetTotal: 0 };

  return {
    current,
    total,
    pages,
    sums,
    generateJobNo: (data = rawData) => generateJobNo(data),
  };
}

export function generateJobNo(data = []) {
  const now = new Date();
  const buddhistYear = now.getFullYear() + 543;
  const year = buddhistYear.toString().slice(-2);
  const month = (now.getMonth() + 1).toString().padStart(2, "0");
  const prefix = `JOB${year}${month}`;

  const jobNos = data
    .map((d) => d.job_no)
    .filter((no) => no?.startsWith(prefix))
    .sort();

  let nextId = "001";
  if (jobNos.length > 0) {
    const last = jobNos[jobNos.length - 1];
    const lastNum = parseInt(last.slice(-3), 10);
    nextId = (lastNum + 1).toString().padStart(3, "0");
  }
  return `${prefix}${nextId}`;

}


